import { render, staticRenderFns } from "./growthScmV0.vue?vue&type=template&id=bef3ced4&scoped=true"
import script from "./growthScmV0.vue?vue&type=script&lang=js"
export * from "./growthScmV0.vue?vue&type=script&lang=js"
import style0 from "./growthScmV0.vue?vue&type=style&index=0&id=bef3ced4&prod&scoped=true&lang=css"
import style1 from "./growthScmV0.vue?vue&type=style&index=1&id=bef3ced4&prod&lang=css"
import style2 from "./growthScmV0.vue?vue&type=style&index=2&id=bef3ced4&prod&scoped=true&lang=css"
import style3 from "./growthScmV0.vue?vue&type=style&index=3&id=bef3ced4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef3ced4",
  null
  
)

export default component.exports